import { ChangeEvent, useState } from "react";
import { CssTextField, Input } from "../../pages/user/UserProfile";
import Button from "../Button";

import ThetaVideoAPI from "../../thetavideoapi";

const AddTutorial = () => {
  const [videoDetails, setVideoDetails] = useState({
    title: "",
    desc: "",
  });
  const [file, setFile] = useState<File>();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setVideoDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    console.log(file);
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  const handleFileUpload = async () => {
    // Check if file is a video
    if (!file) {
      return;
    } else {
      console.log(file);
    }

    if (file.type.split("/")[0] === "video") {
      console.log("File is a video");
    }

    if (videoDetails.title === "" || videoDetails.desc === "") {
      return;
    }

    // Upload video to Theta Video API
    const video = await ThetaVideoAPI.uploadVideo(file);

    console.log(video);
  };

  return (
    <div className="bg-[rgba(255,_255,_255,_0.5)] [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] h-[65vh] mt-5 p-5 grid grid-cols-2">
      <div className="w-[90%] px-4">
        <p className="text-xl text-main-blue">Upload a tutorial video</p>
        <CssTextField
          required
          fullWidth
          id="cv"
          type="file"
          label=""
          size="small"
          margin="normal"
          onChange={handleFileChange}
          helperText="Kindly upload your video here"
        />
        <Input
          id="title"
          label="Video Title"
          name="title"
          value={videoDetails.title}
          onChange={handleChange}
        />
        <CssTextField
          id="desc"
          label="Video Description"
          name="desc"
          margin="normal"
          rows={6}
          value={videoDetails.desc}
          onChange={handleChange}
          multiline
          fullWidth
          required
        />
      </div>
      <div className="flex justify-end items-end w-[80%]">
        <div className="mt-auto h-[12%] ">
          <Button onClick={handleFileUpload}>Upload Tutorial</Button>
        </div>
      </div>
    </div>
  );
};

export default AddTutorial;
